import { createContext } from 'react';

export const MembershipActionsContext = /*#__PURE__*/ createContext<{
    API: any; // formApi
    FormCTAConfig: any;
  }>({
    API: null,
    FormCTAConfig: null,
  });
